//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Config from "../Config/config";
import tabbar from './home/tabbar.vue'
import one   from './home/one.vue'
import two   from './home/two.vue'
import three from './home/three.vue'
import four  from './home/four.vue'
export default {
  name: "home",
  components:{
    tabbar,
    one,
    two,
    three,
    four
  },
  data() {
    return {
      // 选择标签
      active_tag:1,
    };
  },
  methods: {
    // tabbar切换
    changeTab(s){
      this.active_tag = s
    },
    // 获取路径后面openid
    getUrlCode(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
  created() {
    // var ua = navigator.userAgent.toLowerCase();
    // console.log(ua); //UA信息
    // var isWx = /micromessenger/i.test(navigator.userAgent) // 微信
    // var isComWx = /wxwork/i.test(navigator.userAgent);  // 企业微信

    // console.log(isWx);
    // console.log(isComWx);
    
    const code = this.getUrlCode("code");
    const token = sessionStorage.getItem("token");
    if (code && !token) {
      console.log(11111);
      const code = this.getUrlCode("code");
      this.$api.login(code).then((res) => {
        console.log(sessionStorage.getItem("token"));
        if (res === 1 && Config.mode === "pro") {
          window.location.replace("https://mesapp.hfbsoftware.com/#/");
        }
        if (res === 1 && Config.mode === "dev") {
          window.location.replace("http://192.168.31.134:8000/");
        }
      });
    }
    if (!token && !code) {
      console.log(location.href);
      this.$api.getAppid(location.href);
    }
  },
  mounted() {
    if (sessionStorage.getItem("token")) {
      console.log(sessionStorage.getItem("token"));
      this.active_tag = 1
      // 获取图片默认路径
      this.$api.getBaseImgURL().then(res => {
        this.$store.state.BaseImgUrl = res
        sessionStorage.setItem('BaseImgURL',res)
      })
      // 获取账号信息
      this.$post('/app/user/getUser').then(res => {
        let userInfo = JSON.stringify(res)
        sessionStorage.setItem('userInfo',userInfo)
        let role = res.role_id
        sessionStorage.setItem('role',role)
      })
    }
  },
  activated(){
    const is = this.active_tag
    this.active_tag = 0
    setTimeout(() => {
      this.active_tag = is
    }, 800);
  },
  
};



// WEBPACK FOOTER //
// ./src/components/home.vue